export default "skymp5-front/5d4e33cc06956662e90ad8a0aa8e8eaf.gif";